import { Common } from "./type";

export const EN_COMMON: Common = {
  loading: "Loading...",
  error: "Error",
  success: "Success",
  cancel: "Cancel",
  save: "Save",
  edit: "Edit",
  delete: "Delete",
  confirm: "Confirm",
  back: "Back",
  next: "Next",
  previous: "Previous",
  submit: "Submit",
  close: "Close",
  yes: "Yes",
  no: "No",
  copy: "Copy",
  copied: "Copied",
  retry: "Retry",
  confirming: "Confirming...",
  declining: "Declining...",
  submitting: "Submitting...",
  saving: "Saving...",
  done: "Done",
  name: "Name",
  email: "Email",
  date: "Date",
  type: "Type",
  status: "Status",
  unit: "credit(s)",
  and: "and"
};
